export default __webpack_public_path__ + "static/media/Prompt-Medium.509ba13e.ttf";